// extracted by mini-css-extract-plugin
export default {"notificationButton":"Navbar_notificationButton__iT9EJ"};